import { DEFAULT_LANGUAGE, LANGUAGES } from "./i18n";


export const fengSettings = {
  name: 'stvasco',
  version: '0.0.1',
  hmr: true,
  frontUrl: 'sociogigante.com',
  projectName: 'Sócio Gigante',
  clientName: 'Vasco da Gama',
  clientId: 'CNPJ 47.589.413/0001-17',
  clientPhone: '(21) 3955-2011',
  clientEmail: 'atendimento@sociogigante.com',
  clientAddress: 'Avenida Roberto Dinamite, nº:10, Rio de Janeiro - RJ, 20921-060',
  clientPartnership: 'parceriasociogigante@vasco.com.br',
  i18n: {
    DEFAULT_LANGUAGE,
    LANGUAGES
  },
  cache: {
    strategy: 'explicit',
    localStorageKey: 'fengHttpCache',
    ttl: 60000 // 1min (60000) - 5min (300000) - 30min (1800000) - 30min (1800000) - 1h (3600000) - 2h (7200000) - 6h (21600000) - 12h (43200000) - 24h (86400000)
  },
  ui: {
    button: {
      notOutlineFit: {
        primary: {
          light: '',
          dark: '',
        },
        secondary: {
          light: '',
          dark: '',
        }
      },
      outlineFit: {
        primary: '',
        secondary: {
          light: '',
          dark: '80%',
        },
      },
    }
  },
  auth: {
    enableSt: true,
    enableResale: false,
    enableCaptcha: true,
    verifyCPF: true,
    verifyEmail: true,
    keepConnected: true,
    loginForm: {
      title: 'Para primeiro acesso ao novo sistema, clique abaixo em "Gerar nova senha" para receber no seu e-mail cadastrado',
      text: 'Email/CPF',
      forgotPass: 'Gerar nova senha',
      forgotPassText: 'Preencha com o seu e-mail cadastrado no Sócio Gigante e enviaremos um link de recuperação para você. O e-mail só será enviado caso o cadastro seja encontrado.',
      forgotEmailText: 'Caso você tenha esquecido o seu e-mail, entre em contato com o atendimento <a href="/atendimento">clicando aqui</a>.',
      forgotAccountLabel: 'CPF/E-mail',
    },
    firstAccess: {
      enable: true,
      migrationLogic: false,
      ask: {
        password: false,
        terms: false,
        missingData: false
      }
    },
    social: [
        { name: 'google', enabled: true },
        { name: 'facebook', enabled: true }
    ],
    register: {
      enableSt: true,
      showTerms: true,
      fields: {
        genre: true
      },
    },
    staging: {
      enable: false,
      title: 'SEJA BEM-VINDO!',
      subtitle: 'faça parte da torcida que conduz o time',
      description: `
        <p>
          Bloqueio de navegação para ambiente de staging <strong>em fase de teste</strong>.
        </p>
        <p>
          Para liberar navegação, adicione <strong>/login</strong> no final da URL desta página
          e efetue o login com um <strong>usuário administrativo</strong> com
          <strong>perfil 'Administrador', 'Desenvolvedor' ou 'Staging'.
        </p>
        <p>
          <strong>Após validação da funcionalidade, esta mensagem será removida.</strong>
        </p>
      `,
    },
  },
  payment: {
    creditCard : {
      maxAllowed: 3,
      allowedTypes:  
      
        [{ type: 'visa', regex: /^4/ },

        // Mastercard: 51–55 e 2221–2720
        { type: 'mastercard', regex: /^(5[1-5]|2(2[2-9][1-9]|2[3-9]\d|[3-6]\d{2}|7([01]\d|20)))/ },

        { type: 'american-express', regex: /^3[47]/ },
        { type: 'diners', regex: /^30[0-5]/ },

        // JCB: 3528–3589
        { type: 'jcb', regex: /^35(2[89]|[3-8][0-9])/ },

        // Visa Electron
        {
          type: 'visa-electron',
          regex: /^(4026|417500|4508|4844|491[37])/,
        },

        // Maestro
        {
          type: 'maestro',
          regex: /^(5000|5018|5020|5038|6304|6759|676[1-3])/,
        },

        // Hipercard
        {
          type: 'hipercard',
          regex: /^(606282|3841(?:[046])0)/,
        },

        // Discover
        {
          type: 'discover',
          regex: /^(6011|65|64[4-9]|622(12[6-9]|1[3-9]\d|[2-8]\d{2}|9[0-1]\d|92[0-5]))/,
        },

        // Elo
        {
          type: 'elo',
          regex: /^(401178|401179|431274|438935|451416|457393|45763[12]|504175|627780|636297|636368|636369|65003[5-9]|65004[0-9]|65005[01]|65040[5-9]|6504[1-3][0-9]|65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8]|65054[1-9]|6505[5-8][0-9]|65059[0-8]|65070[0-9]|65071[0-8]|65072[0-7]|65090[1-9]|6509[1-6][0-9]|65097[0-8]|65165[2-9]|6516[6-7][0-9]|65500[0-9]|65501[0-9]|65502[1-9]|6550[3-4][0-9]|65505[0-8]|506699|5067[0-6][0-9]|50677[0-8]|509\d{3})/,
        },
      ],
      enableCaptcha: true,
      enableDelete: true
    },
    installments: {
      enableInstallments: false,
      enableMultiInstallments: true,
      multiplePayment: {
        creditCardAllowed: true,
        bankSlipAllowed: true,
        pixAllowed: false,
      },
      subdivision: {
        creditCard: true,
      }
    },
    enableRemission: true
  },
  loading: {
    global: 'ring', // default | ring | orbital | pulse
    local: 'bars' // default | bars | bullets | progress
  },
  homeSettings: {
    scroll: {
      bannerUnlogged: false,
      callToAction: {
        enable: true,
        template: 18,
        redirectScrollTo: true
      },
      tickets: {
        enable: true,
        template: 1
      },
      hero: true,
      tabs: {
        enable: true,
        template: 6,
        showFirst: true
      },
      plans: {
        enable: true,
        enableColorTheme: true
      },
      specialPlans: {
        enabled: true
      },
      exclContent: false,
      testimony: false,
      callToActionFooter: false,
      eventInfo: {
        enable: true,
        template: 1
      },
      partner: {
        enable: true,
        template: 1
      }
    },
    banner: {
      text: 'Acesse',
      className: 'GIGANTE',
      textVote: 'CLIQUE AQUI E VOTE',
      statusButton: 'secondary'
    },
    voting: {
      title: true,
      disclaimer: `*Imagens meramente ilustrativas. A versão final da customização poderá ter modificações quando comparada às versões apresentadas nas imagens acima.`,
    },
    cards: {
      enable: true,
      contentBox: true,
      experiences: true,
      plans: true,
      ticketCards: true,
      tickets: true,
      enableColorTheme: true,
      titles: {
        experiences: 'RESGATES'
      }
    },
    header: {
      legacyMsg: ``,
      templateHeader: 2,
      activeNewPlan: false,
      defaultNotification: `Parabéns! Não existem pendências com seu plano. Aproveite os benefícios de ser Gigante.`,
      waitingApprove: 'Aguarde até que seu plano esteja aprovado para aproveitar todos os benefícios de ser Gigante.',
      hasPendingContract: 'Existem pendências com seu plano. Regularize para aproveitar todos os benefícios de ser Gigante.',

      netPromoterScore: {
        enable: true,
        message: `Participe da pesquisa! A sua opinião é muito importante para nós.`,
        linkMessage: `Clique aqui para avaliar o Vasco`,
        success: {
          title: 'Obrigado por participar da pesquisa',
          message: 'Sua opinião é muito importante'
        }
      },
    }
  },
  letter: {
    template: 10,
    enable: true,
    showLetter: true,
    imgBase: 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/carta-aberta-coutinho.png',
  },
  myAccount: {
    menu: {
      pets: true,
      new: true,
      guest:true,
    },
    biometry: {
      template: 2,
      status: {
        register: {
          title: 'Biometria facial não cadastrada!',
          text: 'Se você ainda não possui sua biometria, siga todas as etapas para cadastrar a sua biometria facial.',
        },
        analisys: {
          title: 'Biometria facial em análise!',
          text: 'Parabéns! Sua face foi cadastrada e agora passa por análise. Acompanhe o status através do seu e-mail.',
        },
        success: {
          title: 'Biometria facial cadastrada!',
          text: 'Parabéns! A sua biometria facial foi cadastrada com sucesso. Aproveite e faça já a compra dos seus ingressos para o próximo jogo.',
        },
        refused: {
          title: 'Biometria facial recusada!',
          text: 'Não foi possível validar o cadastro da sua face com o documento apresentado.',
        },
        exceededAttempts: {
          title: `Biometria facial não cadastrada,<br> tentativas excedidas!`,
          text: 'Você excedeu o limite de tentativas para cadastrar a sua face. Entre em contato com o SAC para mais informações.',
        },
      },
      hasBiometryText: 'Face Cadastrada',
      information: 'Você só poderá efetuar a compra de ingressos após realizar este cadastro.<br>O armazenamento do cadastro biométrico é de responsabilidade única da ticketeira ElevenTickets <a target="_blank" href="https://vasco.eleventickets.com/#!/home">CLIQUE AQUI PARA ACESSAR OS TERMOS</a>.',      
      integration: 'FACIAL_ONBOARDING', //BEPASS, FACIAL_ONBOARDING
      clubName: 'Vasco',
      successMessage: 'Parabéns! Sua biometria facial foi cadastrada e neste momento passa por análise. Acompanhe a aprovação através do seu e-mail.',
    },
    welcomeKit: [
      {
        enable: true,
        title: 'CARTA ABERTA DO COUTINHO',
        description: 'Carta aberta do Coutinho disponível!',
        //order: 1,
        button: 'ABRIR'
      }, 
    ],
    digitalProduct: {
      description: 'Regularize e faça downloads exclusivos.',
    },
    home: {
			showBannerNewLink: true
		},
    nav: [
      { title: 'PLANO', routerLink: '/minha-conta/meu-plano', if: '' },
      { title: 'PERFIL', routerLink: '/minha-conta/meu-perfil', if: '' },
      { title: 'PAGAMENTOS', routerLink: '/minha-conta/pagamentos', if: 'clubLock' },
      { title: 'DEPENDENTES', routerLink: '/minha-conta/dependentes', if: 'clubLock && hasDependents' },
      { title: 'PROPOSTOS', routerLink: '/minha-conta/meus-propostos', if: 'clubLock && isStatutory' },
      { title: 'BIOMETRIA', routerLink: '/minha-conta/biometria', if: '' },
      { title: 'LISTA DE CONVIDADOS', routerLink: '/lista-de-convidado', if: 'hasGuest' },
      // { title: 'ADOTE UM SÓCIO', routerLink: '/minha-conta/adote-um-socio', if: '' },
      // { title: 'ANIMAL', routerLink: '/minha-conta/pets', if: '' }
    ],
    enableColorTheme: true,
    plan: {
      template: 2,
      enableColorTheme: true,
      enableMultiplePlans: true,
      hideAutomaticRenew: true,
      canOptOutAutoResubscribe: ['4394b291b88a3da2577911219fc9b00b', '146cac454424413a7ba05a5f505d9b9a'],
      outAutoResubscribeMsg: 'Confirmando o cancelamento, você perderá os pontos acumulados até então e o tempo de associação. Você poderá fazer um novo plano, mas os pontos não irão retornar. Confirmar o cancelamento do seu período de experimentação do plano?',
      ticketCard: {
        hide: true,
        image: 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/ticketcard.png',
        // image: 'https://vasco-gs.s3.amazonaws.com/website/cards/placeholder.png',
        showImage: true,
        enableRating: false,
        enableStarRating: true,
        showWavePriority: true,
        ratingTitle: 'Onda de Compra - ',
        showRating: true,
        rating: {          
          iconEmpty: 'fengi-pill-empty',
          iconFull: 'fengi-pill-full',
          maxMonthsForStarRating: 48,
          template: 5,
          enable: false,
            enableRatingPlan: [
            '41550f8ed7b8874576f5fdf25e96c592',
            '49214b719bbb25ab3ab0334aca528f58',
            '06ef9b523ee8e6401a020574a00c3d87',
            '4d8ea6822fd955446bcce04e5e8a5a0a',
            '146cac454424413a7ba05a5f505d9b9a',
            '4394b291b88a3da2577911219fc9b00b',
            '06b749bd111792f0edc9ac80497d4602',
          ]
        },
      },
      embassy: {
        active: true,
      },
      statutory: {
        personType: '22b9e50627a50913b3932f6121858539'
      },
      card: {
        discontinuedPlanButton: 'REGULARIZE SEU PLANO',
      }
    },
    profile: {
       showDdiSelect: true,
      complementary: {
        enabled: true,
        fields: {
          nationality: true,
          restrictNationality: true,
          rg: true,
          civilStatus: true,
          education: true,
          residentialPhone: true,
          shirtSize: true,
          shortSize: false,
          shoeSize: false,
          income: false,
          interest: false,
          matchFrequency: true,
          hasChildren: true,
          childrenNumber: true,
          profession: false,
          company: false,
          interestWorkField: false,
          club: false,
          secondaryMail: true,
          twitter: true,
          instagram: true,
          tiktok: true,
          hasPet: true
        },
        options: {
          shirtSize: [
            { value: 'P', label: 'P'},
            { value: 'M', label: 'M'},
            { value: 'G', label: 'G'},
            { value: 'GG', label: 'GG'},
            { value: '3G', label: '3G'},
            { value: '5G', label: '5G'},
            { value: '7G', label: '7G'},
          ]
        }
      },
      document: {
        allowedProps: ['cpf', 'form', 'identity', 'residence'],
      }
    },
    address: {
      editBlock: false,
      addressNumberModifier: true
    },
    dependents: {
      template: 2,
      enableRegister: true,
      enableAfterRegisterMsg: false,
      complementary: {
        enabled: true,
        fields: {
          nationality: true,
          rg: true,
          civilStatus: true,
          education: false,
          residentialPhone: false,
          shirtSize: false,
          shortSize: false,
          shoeSize: false,
          income: false,
          interest: false,
          matchFrequency: false,
          hasChildren: false,
          childrenNumber: false,
          profession: false,
          company: false,
          interestWorkField: false,
          club: false,
          religion: false,
        },
        options: {
          shirtSize: [
            { value: 'P', label: 'P'},
            { value: 'M', label: 'M'},
            { value: 'G', label: 'G'},
            { value: 'GG', label: 'GG'},
            { value: '3G', label: '3G'},
            { value: '4G', label: '4G'},
            { value: '7G', label: '7G'},
          ]
        }
      },
      pet: {
        disableSubscribe: true
      }
    },
    socialNetworks: {
      enabled: true
    },
    ticketCards: {
      ticketCardTemplate: 2,
      textWarn: {
        enableForm: true,
        textInfo: `<strong>ATENÇÃO</strong> - Ative sua carteirinha clicando no botão abaixo <strong>apenas</strong> se já tiver com ela em mãos para usufruir dos benefícios`
      }
    },
    giftCard: {
      enable: true
    },
    guestList: {
      name: 'Lista de Convidados',
      requiredFields:[
        "email",
        "celular",
        "cep",
        "bairro",
        "logradouro",
        "pais",
        "estado",
        "cidade"
      ],
      // listName: 'FAVORITOS',
      // guestLimit: 5, // Depreciado. Vem no profile
      // guestChangeMonths: 6, // Depreciado. Informação na propriedade 'info'
      create: {
        title: 'CADASTRO DE CONVIDADOS',
        subtitle: 'PREENCHA OS CAMPOS ABAIXO COM OS DADOS COMPLETOS DO SEU CONVIDADO PARA PROSSEGUIR COM O CADASTRO',
      },
      edit: {
        title: 'EDIÇÃO DE CONVIDADO',
        subtitle: 'PREENCHA OS CAMPOS ABAIXO COM OS DADOS COMPLETOS DO SEU CONVIDADO PARA PROSSEGUIR COM O CADASTRO',
        warning: 'Certifique-se de que todas as informações estão corretas. Após prosseguir, a edição do convidado só será possível no próximo ciclo de edição/exclusão.',
      },
      info: '<p>* Só será permitido a exclusão ou edição de um convidado da Lista de Convidados após 6 meses de inclusão ou última edição.</p>',
    },
    proponenteEnable: true
  },
  // partnersSettings: {
  //   enableMoreInfo: false,
  //   enableColorTheme: true,
  // },
  partnersSettings: {
    enableMoreInfo: false,
    enableColorTheme: true,
    enablePartiu: false,
    enableLocaleFilter: true,
    becomePartner: {
      enable: true,
      address: {
        numberMaxLength: 4,
        enableLimitCharacter: true,
      },
      discount: {
        increment: 5,
        type: "percentage", // Available: percentage [default] | amount
      },
      terms: {
        pageTitle: null,
        contentKeywords: ['contrato', 'parceria']
      }
    },
    enableFilters: {
      category: false,
      state: false,
      city: false,
      neighbourhood: false
    }
  },
  experiencesSettings: {
    menu: {
      catalog: true,
      howToScore: true,
      points: true,
      rescued: true
    },
    enableSocioClub: false,
    catalog: {
      cardTemplate: 2,
    },
    howScore: {
      cardTemplate: 2,
    },
    points: {
      cardTemplate: 2,
    },
    rescues: {
      cardTemplate: 2,
    },
  },
  faqSettings: {
    faqTemplate: 5,
    mockFaq: false,
    enableColorTheme: true,
    contacts: {
      chat: {
        active: true,
        availability: 'de segunda a sexta, das 09h às 18h, e aos sábados, das 09h às 12h',
      },
      email: {
        active: true
      }
    },
    showSACNumber: false
  },
  headerSettings: {
    headerTemplate: 'fngst-1',
    floatingLogin: false,
    enableCounter: true,
    counterPartnersNickname: 'GIGANTES',
    enableNotifications: true,
    hideCounterOnPage: ['/transparencia', '/experiencias/catalogo', '/experiencias/como-pontuar'],
    enableMobileMenu: true,
    nav: [
      { title: 'HOME', routerLink: '/home', routerLinkActiveOptions:  { exact: true } },
      { title: 'MINHA CONTA', routerLink: '/minha-conta/meu-plano', routerLinkActiveOptions: { exact: false } },
      { title: 'PLANOS', routerLink: '/planos', routerLinkActiveOptions: { exact: true } },
      // { title: 'PARCEIROS', routerLink: '/parceiros', routerLinkActiveOptions: { exact: true } },
      { title: 'CLUBE DE VANTAGENS', routerLink: `https://clubedevantagensdogigante.com.br/home`, routerLinkActiveOptions: { exact: true }, click: 'externalurl'  },
      { title: 'RESGATES', routerLink: '/experiencias', routerLinkActiveOptions: { exact: false } },
      // { title: 'CONTEÚDO EXCLUSIVO', routerLink: '/conteudo-exclusivo', routerLinkActiveOptions: { exact: true } },
      { title: 'INGRESSOS', routerLink: '/ingressos', routerLinkActiveOptions: { exact: true } },
      // { title: 'TRANSPARÊNCIA', routerLink: '/transparencia', routerLinkActiveOptions: { exact: true } },
      { title: 'CAPITANIAS', routerLink: '/capitanias', routerLinkActiveOptions: { exact: true } },
      { title: 'MINHA CAPITANIA', routerLink: '/minha-capitania', routerLinkActiveOptions: { exact: true } },
      { title: 'PRODUTOS DIGITAIS', routerLink: '/produtos-digitais', routerLinkActiveOptions: { exact: true } },
      { title: 'ATENDIMENTO', routerLink: '/atendimento', routerLinkActiveOptions: { exact: true } },
    ],
    navLight: [
      { title: 'MINHA CONTA', routerLink: '/minha-conta/meu-plano', routerLinkActiveOptions: { exact: false } },
      { title: 'PLANOS', routerLink: 'e/planos', routerLinkActiveOptions: { exact: true } },
      { title: 'CLUBE DE VANTAGENS', routerLink: `https://clubedevantagensdogigante.com.br/home`, routerLinkActiveOptions: { exact: true }, click: 'externalurl' },
      // { title: 'PARCEIROS', routerLink: '/parceiros', routerLinkActiveOptions: { exact: true } },
      { title: 'RESGATES', routerLink: '/experiencias', routerLinkActiveOptions: { exact: false } }, 
      { title: 'INGRESSOS', routerLink: '/ingressos', routerLinkActiveOptions: { exact: true } },
      // { title: 'ATENDIMENTO', routerLink: '/atendimento', routerLinkActiveOptions: { exact: true } },
    ],
    activeSecondaryNavMenu: true,
    primaryNavMenuMinItens: 1, // por conta do menu capitanias
    moreItensButtonHTML: 'MAIS &nbsp; <i class="fengi-plus-circle"></i>',
    secondaryNavItens: [
      'ATENDIMENTO',
      'PRODUTOS DIGITAIS',
    ],
    unloggedNav: [
      { title: 'Ingressos', routerLink: '/ingressos', routerLinkActiveOptions: { exact: true } },
      { title: 'Planos', routerLink: '/planos', scrollLink: 'st-pricing', routerLinkActiveOptions: { exact: true } },
      { title: 'Cartão Presente', routerLink: '/presente', routerLinkActiveOptions: { exact: true } },
    ],
    hidePoints: true
  },
  footerSettings: {
    footerTemplate: 'fngst-1',
    social: [
      { icon: 'x', href: 'https://twitter.com/sociogigante' },
      { icon: 'instagram', href: 'https://www.instagram.com/sociogigante' },
      // { icon: 'youtube', href: 'https://www.youtube.com' },
      { icon: 'facebook_icon', href: 'https://www.facebook.com/sociogigante/' }
    ],
    nav: [
      { title: 'HOME', routerLink: '/', click: '', clickParam: '', if: 'notHome' },
      { title: 'PLANOS', routerLink: '/planos', click: '', clickParam: '', if: '' },
      // { title: 'PARCEIROS', routerLink: '/parceiros', routerLinkActiveOptions: { exact: true } },
      { title: 'CLUBE DE VANTAGENS', routerLink: `https://clubedevantagensdogigante.com.br/home`, routerLinkActiveOptions: { exact: true }, click: 'external'  },
      { title: 'RESGATES', routerLink: '/experiencias', click: '', clickParam: '', if: '' },
      // { title: 'CONTEÚDO EXCLUSIVO', routerLink: '/conteudo-exclusivo', routerLinkActiveOptions: { exact: true } },
      { title: 'INGRESSOS', routerLink: '/ingressos', click: '', clickParam: '', if: '' },
      //{ title: 'TRANSPARÊNCIA', routerLink: '/transparencia', click: '', clickParam: '', if: '' },
      { title: 'CAPITANIAS', routerLink: '/capitanias', routerLinkActiveOptions: { exact: true } },
      { title: 'ATENDIMENTO', routerLink: '/atendimento', click: '', clickParam: '', if: '' },
      { title: 'LOGOUT', routerLink: '', click: 'logout', clickParam: '', if: 'isAuth' },
    ],
    enableTerms: true,
    enableTransparencyLink: true
  },
  plans: {
      enableDocumentForeigner: true,
      tooltipVerify: [
        {planID:['2a35104161d5cfcc6739bd19c5e542f8'], message: ''},
        {planID:['5cf6dcfdbb6f90dddee9c1391d516027'], message: ''}
      ],
    tooltipMessage: 'Você precisa deslogar e criar uma nova conta para seguir com a adesão deste plano',
    template: 'fngst-1',
    cardPlaceholder: "https://vasco-gs.s3.amazonaws.com/website/cards/placeholder.png",
    enableAsterisk: true,
    enableDependents: false,
    subscribeText: 'ASSOCIE-SE',
    disableOffState: true,
    invertOrderMobile: true,
    descriptions: [
      {
        dscplano: "Geral",
        idplano: "4875c93676beeab0881e7fb1c7d9b462",
        description: `
              <li>
                  Direito a voto e demais atribuções previstas no estatuto do clube
              </li>
              <li>
                  <b>50% de desconto</b> no ingresso de todos os setores
              </li>
              <li>
                  Acesso gratuito ao clube <b>Vasco + Alegria</b>
              </li>
              <li>
                  10% de desconto na <b>Vasco Store</b>
              </li>
              <li>
                  <strong>6 Estrelas</strong> fixas no rating<br>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
              </li>
              <li>
                  Desconto de 20% na Taxa de Admissão para mulheres.
              </li>
              <li>
                  Descontos em nossa rede de parceiros
              </li>
              <li>
                  Experiências e Super Experiências <b>Exclusivas</b>
              </li>
              <span class="general">
                  <ul>
                      <li>
                          <b>
                              Taxa de Admissão
                          </b>
                      </li>
                      <li>
                          R$ 750,00
                      </li>
                  </ul>
              </span>
          `
      },
      {
        idplano: "233b7c3b5a6fcbc1f73326dbb8efcf9e",
        dscplano: "Proprietário Diamante",
        description: `
              <li>
                  Direito a voto e demais atribuções previstas no estatuto do clube
              </li>
              <li>
                  <b>50% de desconto</b> no ingresso de todos os setores
              </li>
              <li>
                  Acesso gratuito ao clube <b>Vasco + Alegria</b>
              </li>
              <li>
                  10% de desconto na <b>Vasco Store</b>
              </li>
              <li>
                  <strong>6 estrelas</strong> fixas no rating<br>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
              </li>
              <li>
                  Desconto de 20% no Título para mulheres.
              </li>
              <li>
                  Descontos em nossa rede de parceiros
              </li>
              <li>
                  Experiências e Super Experiências <b>Exclusivas</b>
              </li>

              <span>
                  <ul>
                      <li>
                          <b>
                          Compra do Título
                          </b>
                      </li>
                      <li>
                          R$ 2.500,00
                      </li>
                  </ul>
              </span>
          `
      },
      {
        idplano: "5cf6dcfdbb6f90dddee9c1391d516027",
        dscplano: "Almirantinho",
        description: `
              <li>
                  <b>Exclusivo</b> para menores de 12 anos
              </li>
              <li>
                  <b>Carteirinha física</b> para mostrar esse amor que só cresce
              </li>
              <li>
                  Ações promocionais <b>exclusivas</b>
              </li>
              <li>
                  Descontos em nossa <b>rede de parceiros</b>
              </li>
              <li>
                  Possibilidade de retirada online do ingresso de gratuidade legal direto na carteirinha.
              </li>
              <li>
                  Experiências
              </li>
          `
      },
      {
        idplano: "2a35104161d5cfcc6739bd19c5e542f8",
        dscplano: "Plano Animal",
        description: `
              <li>
                  <b>Exclusivo</b> para o seu bichinho
              </li>
              <li>
                  <b>Carteirinha física</b> com foto
              </li>
              <li>
                  Ações promocionais <b>exclusivas</b>
              </li>
              <li>
                  Descontos em nossa <b>rede de parceiros</b>
              </li>
              <li>
                  Experiências
              </li>
          `
      },
      // {
      //   idplano: "4394b291b88a3da2577911219fc9b00b",
      //   dscplano: "Camisas Negras",
      //   description: `
      //         <li>
      //             <b>Até 10% de desconto</b> no ingresso de arquibancada.
      //         </li>
      //         <li>
      //             Descontos em nossa <b>rede de parceiros</b>
      //         </li>
      //         <li>
      //             10% de desconto na <b>Vasco Store</b>
      //         </li>
      //         <li>
      //             <b>Carteirinha física</b> para mostrar o amor que só você entende
      //         </li>
      //         <li>
      //             <strong>1 estrela</strong> fixa no rating<br>
      //             <i class="icon-star-full"></i>
      //         </li>
      //     `
      // },
      // {
      //   idplano: "146cac454424413a7ba05a5f505d9b9a",
      //   dscplano: "Norte a Sul",
      //   description: `
      //         <li>
      //             <b>Até 50% de desconto</b> no ingresso de arquibancada
      //         </li>
      //         <li>
      //             Acesso gratuito ao clube <b>Vasco + Alegria</b>
      //         </li>
      //         <li>
      //             10% de desconto na <b>Vasco Store</b>
      //         </li>
      //         <li>
      //             <strong>2 estrelas</strong> fixas no rating<br>
      //             <i class="icon-star-full"></i>
      //             <i class="icon-star-full"></i>
      //         </li>
      //         <li>
      //             Exclusivo para quem mora fora <b>do estado do Rio de Janeiro</b>
      //         </li>
      //         <li>
      //             Descontos em nossa rede de parceiros
      //         </li>
      //         <li>
      //             Experiências
      //         </li>
      //     `
      // },
      {
        idplano: "2beb25a598c27a9873a3a03d4f292f30",
        dscplano: "Caldeirão",
        description: `
              <li>
                  <b>Até 70% de desconto</b> no ingresso de arquibancada
              </li>
              <li>
                  Acesso gratuito ao clube <b>Vasco + Alegria</b>
              </li>
              <li>
                  10% de desconto na <b>Vasco Store</b>
              </li>
              <li>
                  <strong>2 estrelas</strong> fixas no rating<br>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
              </li>
              </li>
              <li>
                  Descontos em nossa <b>rede de parceiros</b>
              </li>
              <li>
                  Experiências
              </li>
          `
      },
      {
        idplano: "e785a1de0eb4fbea49afd22478cf5e4f",
        dscplano: "Colina",
        description: `
              <li>
                  <b>Até 70% de desconto</b> no ingresso de <b>todos</b> os setores
              </li>
              <li>
                  Acesso gratuito ao clube <b>Vasco + Alegria</b>
              </li>
              <li>
                  10% de desconto na <b>Vasco Store</b>
              </li>
              <li>
                  <strong>3 estrelas</strong> fixas no rating<br>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
              </li>
              </li>
              <li>
                  Até 2 convidados** com até 50% de desconto no ingresso de <b>todos os setores</b>
              </li>
              <li>
                  Descontos em nossa <b>rede de parceiros</b>
              </li>
              <li>
                  Experiências
              </li>
          `
      },
      {
        idplano: "7b58405947a99fbf527d31e176b7e1b5",
        dscplano: "Caldeirão Mais",
        description: `
              <li>
                  <b>100% de desconto</b> no ingresso de arquibancada
              </li>
              <li>
                  Acesso gratuito ao clube <b>Vasco + Alegria</b>
              </li>
              <li>
                  10% de desconto na <b>Vasco Store</b>
              </li>
              <li>
                  <strong>4 estrelas</strong> fixas no rating<br>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
              </li>
              </li>
              <li>
                  Até 2 convidados** com até 50% de desconto no ingresso de arquibancada
              </li>
              <li>
                  Descontos em nossa <b>rede de parceiros</b>
              </li>
              <li>
                  Experiências
              </li>
          `
      },
      {
        idplano: "cb6800e076a4a8739541a2c4b9139d09",
        dscplano: "Colina Mais",
        description: `
              <li>
                  <b>100% de desconto</b> no ingresso de todos os setores
              </li>
              <li>
                  Acesso gratuito ao clube <b>Vasco + Alegria</b>
              </li>
              <li>
                  10% de desconto na <b>Vasco Store</b>
              </li>
              <li>
                  <strong>5 estrelas</strong> fixas no rating<br>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
                  <i class="icon-star-full"></i>
              </li>
              <li>
                  Até 4 convidados** com até 50% de desconto no ingresso de <b>todos os setores</b>
              </li>
              <li>
                  Descontos em nossa <b>rede de parceiros</b>
              </li>
              <li>
                  Experiências
              </li>
          `
      },
      // {
      //   idplano: "06b749bd111792f0edc9ac80497d4602",
      //   dscplano: "Sócio Dinamite",
      //   description: `
      //         <li>
      //             <b>100% de desconto</b> no ingresso de todos os setores
      //         </li>
      //         <li>
      //             Acesso gratuito ao clube <b>Vasco + Alegria</b>
      //         </li>
      //         <li>
      //             10% de desconto na <b>Vasco Store</b>
      //         </li>
      //         <li>
      //             <strong>6 estrelas</strong> fixas no rating<br>
      //             <i class="icon-star-full"></i>
      //             <i class="icon-star-full"></i>
      //             <i class="icon-star-full"></i>
      //             <i class="icon-star-full"></i>
      //             <i class="icon-star-full"></i>
      //             <i class="icon-star-full"></i>
      //         </li>
      //         <li>
      //             1 convidado** com 100% de desconto e 1 com 50% de desconto no ingresso
      //         </li>
      //         <li>
      //             1 Camisa Oficial <b>por ano</b>
      //         </li>
      //         <li>
      //             1 Box Exclusivo com <b>itens do clube</b> por ano
      //         </li>
      //         <li>
      //             1 visita por ano ao <b>CT</b> e <b>SJ</b> (com almoço no Restaurante do Almirante)
      //         </li>
      //         <li>
      //             1 Entrada <b>gratuita</b> em eventos pagos (Jogue na Colina, Tour da Colina e mais)
      //         </li>
      //         <li>
      //             Descontos em nossa <b>rede de parceiros</b>
      //         </li>
      //         <li>
      //             Experiências e Super Experiências <b>Exclusivas</b>
      //         </li>
      //     `
      // },
    ],
    registrationInClubeTitle:`<strong>Atenção!</strong>`,
    registrationInClube: true,
  },
  specialPlan: {
    template: 2,
  },
  xRay: {
    enableFeatured: false,
    featuredTemplate: 3,
    financialTemplate: 5,
    enableCounter: false,
    enableTabBackgroundColor: true,
    enableStates: true,
    enableCities: true,
    enableDistricts: true,
    enablePlans: true,
    enablePaymentMethod: true,
    enableAge: true,
    enableSex: true,
    enableXRay: true,
    xRayLabel: 'Raio-X',
    enableXRayActionBackgroundColor: true,
    chartFontColor: '#000000',
    enableFinancial: false,
    enableTransparency: true,
    enableButtonDonwloadTransparency: true,
    linkDownloadTrnasparency: 'https://vasco-gs.s3.amazonaws.com/website/downloads/gigante-socios-ativos-07-2022.pdf',
    textButtonDownloadTransparency: 'Faça o download da listagem de sócios ativos em 31/07/2022',
    transparencyWithSum: true,
    tranparencyMonthsNameType: 'fullName', // fullName | shortName,
  },
  embassies: {
    template: 4,
    myEmbassyTemplate: 1,
    nicknameSingular: 'Capitania',
    nicknamePlural: 'Capitanias',
    uploadPhoto: true,
    enableTabOpenValidation: true,
    disabledEditMode: true,
    showFanCounter: false,
    personTypes: {
      'FENG20001': 'CAPITANIAS',
    },
    embassiesPage: {
      beforeTableHTML: `
        <h1>Capitanias do <strong>GIGANTE</strong></h1>
        <p>
          As capitanias do GIGANTE fortalecerão a conexão entre o clube e sua torcida.
        </p>
      `,
      afterTableHTML: `
        <p></p>
      `,
      inactiveEmbassyWarning: `
        <p>Sua capitania foi desativada pela administração do clube. Por favor, entre em contato com a secretaria, no número (21) 2222-2222, para entender como você pode reativá-la.</p>
      `,
    },
    createEmbassy: {
      template: 'fngst-1',
      agreementLabel: 'Eu concordo com os termos de uso da plataforma de criação de uma capitania.',
      defaultMembersCount: 4,
      maxMembersInput: 10,
      requireMembersCPF: false,
      requireEmbassyPassword: false,
      allowInternationalAddress: true,
      requireMembersCPFWarning: '<p>Caso não queira adicionar membro agora você poderá fazer isso mais tarde através da tela administrativa de sua capitania.<br />Para isso, basta excluir os campos clicando nas lixeiras.</p>',
      requireMembersCPFNoFieldMessage: '<p>Nenhum membro será adicianado no momento.<br />Faça isso mais tarde através da tela administrativa de sua capitania ou clique no botão abaixo para criar novos campos.</p>',
      CPFNotFoundSubstring: 'CPF(s) não encontrado(s): ',
      BelongsToAnotherEmbassySubstring: 'Sócio(s) já cadastrado(s) a uma capitania: ', 
      modal: {
        success: {
          title: `
            <h3>Parabéns, você acaba de solicitar a criação de sua capitania!</h3>
          `,
          description: `
            <p>Os seus primeiros membros irão receber uma notificação em suas contas e com isso poderemos dar continuidade aprovação e criação da capitania.</p>
          `,
        },
        memberWarning: {
          title: `
            <h3>Esse(s) membro(s) já faz(em) parte de uma capitania!</h3>
          `,
          description: `
            <p>Identificamos que o(s) CPF(s) {{MEMBERS_CPF}} já faz(em) parte de alguma capitania. Cada sócio só pode pertencer a uma capitania.</p>
          `,
        },
        notFound: {
          title: `
            <h3>Usuários não encontrados!</h3>
          `,
          description: `
            <p>Não identificamos os usuários abaixo:<br /> {{USERS}}</p>
          `,
        }
      }
    },
    howScorePage: {
      plans: [],
      otherWays: [],
    },
  },
  checkout: {
    totalDifferenceModal: {
      title: 'Informação sobre o saldo do plano anterior',
      content: `<p>
            <strong>1 - O que representa o saldo do plano anterior?</strong>
          </p>
          <p>
            É o valor do plano anterior que já foi pago, mas ainda não havia sido utilizado quando o novo plano foi contratado. Esse valor é convertido em crédito e utilizado como abatimento no novo contrato.<br>
            Exemplo: Havia um saldo de R$ 300,00 no plano anterior, correspondente a 3 parcelas de R$ 100,00.<br>
          </p>

        <p>
          <strong>2 - Como esse valor é utilizado como abatimento no novo contrato?</strong>
        </p>
        <p>
          O crédito do plano anterior é descontado no valor do novo contrato, sendo cobrada apenas a diferença.<br>
          Exemplo: Novo contrato de R$ 2.000,00 - crédito de R$ 300,00 = R$ 1.700,00, parcelado em 12 vezes de R$ 141,66.<br>
        </p>

        <p>
          <strong>3 - Como as cobranças podem aparecer na fatura do cartão?</strong>
        </p>
        <p>
          A fatura pode apresentar cobranças do plano anterior e do novo plano ao mesmo tempo. Isso ocorre porque as parcelas do plano anterior, já lançadas no cartão, continuam sendo cobradas normalmente, pois o valor correspondente já foi utilizado como crédito para reduzir o valor do novo contrato.<br>
          Exemplo: Parcela plano anterior: R$ 100,00. Parcela plano novo: R$ 141,66.<br>
        </p>

        <p>
          <strong>4 - Por que podem existir cobranças simultâneas?</strong>
        </p>
        <p>
          As parcelas do plano anterior continuam sendo cobradas até o fim do parcelamento, enquanto começam as cobranças do novo plano. Não há cobrança em duplicidade, pois o saldo do plano anterior já foi abatido do novo contrato. A soma das parcelas restantes do plano anterior com as parcelas do novo plano, corresponde exatamente ao valor total do novo contrato.<br>
          Exemplo: Restavam 3 parcelas de R$ 100,00 do plano anterior. Elas continuam sendo cobradas, enquanto são cobradas também as 12 parcelas de R$ 141,66 do novo contrato. Ao final, a soma dos valores corresponde aos R$ 2.000,00, valor total do novo plano.<br>
        </p>`
    },
    allowGiftCardForRedirecting: true,
    defaultDuration: '12',
    maxGuests: false,
    showPaymentMethods: true,
    comingSoonPaymentSlip: false,
    changeDurationPlan: true,
    showDuration: true,
    modalSixPeriodicity: {
      enabled: false,
      title: 'ATENÇÃO',
      message: `
        Os planos com duração semestral não possuem o benefício do kit de boas-vindas.
        Você receberá apenas a carteirinha. Caso deseje receber o kit, altere a periodicidade para Anual.
      `
    },
    disableSteloMessage: true,
    offState: {
      state: 'RJ',
      modalOffState: {
        enabled: false,
        title: 'ATENÇÃO',
        message: `
          Você selecionou um plano fora do estado do Rio de Janeiro, iremos te redirecionar para página de planos para selecionar o plano correto.
        `
      }
    },
    offCity: {
      city: 'Rio de Janeiro',
      districts: [],
      modalOffCity: {
        enabled: true,
        title: 'ATENÇÃO',
        message: `
          Você selecionou um plano fora do Rio de Janeiro, iremos te direcionar para a página de planos para selecionar o plano correto.
        `
      }
    },
    successPage: {
      enabled: true,
      title: 'Pagamento processado!',
      message: `Seja bem vindo ao Sócio Gigante.`
    },
    successPageSe: {
      enabled: true,
      title: 'Agora falta pouco.',
      message: `Seu contrato será gerado dentro de instantes.`
    },
    successDonationPage: {
      enabled: true,
      title: 'Obrigado por apadrinhar um Gigante!',
      message: `Sabemos o tamanho desse gesto. Juntos somos mais fortes! Um
      vascaíno sempre estará junto com outro vascaíno. Se você quiser aumentar essa corrente, pode apadrinhar outras
      pessoas. O sentimento não pode parar!`
    },
    boletoPage: {
      enabled: true,
      title: 'Boleto gerado com sucesso!',
      message: `Agora falta pouco! Pague o seu boleto até a data de vencimento.`
    },
    pixPage: {
      enabled: true,
      title: 'Código PIX gerado com sucesso',
      message: `Agora falta pouco! Pague a fatura gerada através do QR Code abaixo.`
    },
    paymentFailPage: {
      enabled: true,
      title: 'Ocorreu um erro ao efetuar o seu pagamento!',
      message: `Não foi possível processar o seu pagamento na forma de pagamento selecionada.`
    },
    register: {
      disableForeignCheckbox: true,
      address: {
        disableForeign: true
      }
    },
    enableValidator: true
  },
  events: {
    shield: "https://vasco-gs.s3.amazonaws.com/website/images/escudo.png",
    background: null,
    name: "VASCO",
    template: null,
    ticketing: 'SUPERINGRESSO', // Available Options: FCARD / MBILHETE / TICKETHUB / SUPERINGRESSO
    showClubLink: true,
    // clubLink: 'Eleven Tickets em vasco.eleventickets.com',
    clubLinkSuperingresso: 'Eleven Tickets em vasco.eleventickets.com',
    clubLinkFcard: 'a Futebol Card',
    showMoreInfo: false, // Available Options: FCARD / MBILHETE / TICKETHUB / SUPERINGRESSO
    showMyTickets: true,
    hideBuyTicketForPlans:['955ec6e978b8881255cd3bd58dd5d650'], //'100001'
    restrictedActivationStates: [
      "102", "200", "204", "205", "206", 
      "301", "302", "303", "304", "305", "306", "307", "308",
      "401", "402", "403", "404", "405", "406", "407", "408", "409",
      "410", "411", "412", "413", "414", "415"
    ],
    showTicketsClose: true,
    showRating: true,
    multTicketeira: true,
    ratingText: 'Onda de compra',
    showTextNextWave: 'Vendas para sua onda',
    enableTextNextWave: true,
    soonBlocked: true,
    myTicketsEvent: 'e78f72970d783ab3f9f0e852d5d12681',
    banner: {
      template: 1
    },
    integration: {
      enableTicketBalance: true
    }
  },
  virtualTicketCard: {
    template: 5,
    enable: true,
    allowedPlans: ['633d1b8cba9fd9730688f2def4323a86'],  // vazio: todos podem // com algum id: somente aqueles ids que podem
    buttonText: '',
    downloadText: '',
    img: {
      cardLogo: 'data:image/png;base64,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',
      button:'https://vasco-gs.s3.amazonaws.com/prod/assets/images/gigante-pass-img.png',
    },
    backgroundColor: "#000",
    color: '#fff',
  },
  terms: {
    splitted: true,
    showTerms: true,
    termsURL: {
      url: null,
      route: '/termos-de-uso',
      pageTitle: 'Termos de Uso',
      contentKeywords: ['termos', 'uso'],
    },
    privacyURL: {
      url: null,
      route: '/politica-de-privacidade',
      pageTitle: 'Política de Privacidade',
      contentKeywords: ['politica', 'privacidade']
    },
    individualAgreement: true,
    showBiometryFooter: true
  },
  dependents: {
    pet: {
      texts: {
        step_1: {
          title: "qual a espécie do seu PET?",
          subtitle: `Oba! Mais um $tipoAnimal<br /> chegando a colina!`
        },
        step_2: {
          title: "Estamos curiosos pra conhecer mais sobre seu PET! É um menino ou menina?"
        },
        step_3: {
          title: "Estamos curiosos pra conhecer mais sobre seu PET!",
        },
        step_4: {
          title: "Nossa hora favorita! Envie uma foto do seu PET. Ela estará em seu cartão ingresso do Plano Animal."
        },
        modal: {
          title: "Este plano só está disponível para titulares de qualquer um dos planos convencionais de sócio torcedor.",
          subtitle: `A adesão do Plano Animal deve ser feita na página <strong>"Minha Conta"</strong>, na aba <strong>"Animal"</strong>.`,
          descripition: "Ir para Minha Conta > Animal"
        },
        tab: {
          title:"  PLANO <span>ANIMAL</span>",
          subtitle: "Cadastre ou adicione seus Pet's.",
          description: " Caso não possua foto valida, a carterinha do pet não poderá ser emitida!"
        }
      }
    }
  }
}
